// import { useState } from 'react'
// import { notification } from 'antd'
// import { useStoreActions } from 'easy-peasy'
// import classnames from 'classnames'
// import dayjs from 'dayjs'

// import _every from 'lodash/every'
// import _isEmpty from 'lodash/isEmpty'

// import Paragraph from 'components/Paragraph'
import Title from 'components/Title'
import Image from 'components/Image'
import Button from 'components/Button'
import Link from 'components/Link'

import Styled from './styled'

export default function VoucherDetail({ voucherdata, isShowPromocode }) {
  // const getMyVouchers = useStoreActions(actions => actions.auth.getMyVouchers)

  // const [isCollected, setIsCollected] = useState(null)
  // const [copied, setCopied] = useState(false)

  // const id = voucherdata?.id
  const title = voucherdata?.title
  const coverImage = voucherdata?.bannerImage?.[0]?.url

  // const description = voucherdata?.description
  const content = voucherdata?.content
  // const isHiddenPromocode = voucherdata?.promotion?.isHidden || false
  // const termCondition = voucherdata?.termCondition
  // const promocode = voucherdata?.promotion?.promocode
  const reservationLink = voucherdata?.redirectUrl || '/'
  // const buttonTitle = voucherdata?.buttonTitle

  return (
    <Styled>
      <div className="block image-block">
        <Image src={coverImage} imgixWidth={1920} />
      </div>

      <div className="container">
        {/* {promocode && (!isHiddenPromocode || isShowPromocode) && (
          <div className="promocode-block">
            <div className={classnames('promocode', { copied })}>
              <Paragraph>{promocode}</Paragraph>
            </div>
            <div
              className="copy"
              onClick={() => {
                navigator.clipboard.writeText(promocode)
                setCopied(true)
                notification.success({
                  message: 'คัดลอกแล้ว',
                })
              }}
            >
              <Paragraph>คัดลอก</Paragraph>
            </div>
          </div>
        )} */}

        <div className="block">
          <Title level={1}>{title}</Title>
          {/* <Paragraph>{brand}</Paragraph> */}
        </div>

        {/* <div className="block">
          <Title level={4} className="text-title">
            ระยะเวลาโปรโมชั่น
          </Title>
          <Paragraph>
            {dayjs(validStartDate).format('DD MMM YYYY')} -{' '}
            {dayjs(validEndDate).format('DD MMM YYYY')}
          </Paragraph>
        </div> */}

        {/* <div className="button-collet-block">
          <Button
            block
            disabled={isExpired || isRedeemed || isCollected}
            onClick={handleCollectVoucher}
            className={classnames({ green: isCollected, gray: isExpired || isRedeemed })}
          >
            {wordingVoucherButton}
          </Button>
        </div> */}

        {/* {description && (
          <div className="block">
            <Paragraph className="text-description">{description}</Paragraph>
          </div>
        )} */}

        {content && (
          <div className="block">
            <Title level={4} className="text-title">
              รายละเอียด
            </Title>
            <div className="html-content" dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        )}

        {/* {termCondition && (
          <div className="block">
            <Title level={4} className="text-title">
              เงื่อนไขและข้อกำหนด
            </Title>
            <div className="html-content" dangerouslySetInnerHTML={{ __html: termCondition }} />
          </div>
        )} */}

        <div className="button-block">
          <Link href={reservationLink}>
            <Button dynamic>จองบริการ</Button>
          </Link>
        </div>
      </div>
    </Styled>
  )
}
